// PDP buy-rail interactions (V2 design) — kinetics quantity stepper (spring
// bump, kinetics.colorion.co pattern) + radix-style single-open accordion +
// the circular donut-ring text + the Discovery Set bottle-stage fit.
// Variant switching / Add to Cart live in sections/mz-product-hero.liquid (they need the
// per-variant JSON that only that section renders) — this file stays product-agnostic.
(function () {
  var rev = document.getElementById('pvReveal');
  if (!rev) return;

  // ── stepper ──
  var val = rev.querySelector('.step-val');
  var qty = 1;
  rev.querySelectorAll('.step-btn').forEach(function (b) {
    b.addEventListener('click', function () {
      qty = Math.max(1, qty + (+b.dataset.d));
      val.textContent = qty;
      var qIn = document.getElementById('pvQty');   // product form's quantity, for Buy it now
      if (qIn) qIn.value = qty;
      val.classList.remove('bump');
      void val.offsetWidth;                       // restart the spring
      val.classList.add('bump');
      setTimeout(function () { val.classList.remove('bump'); }, 350);
    });
  });

  // ── accordion (one open at a time) ──
  var items = [].slice.call(rev.querySelectorAll('.pv-acc-item'));
  items.forEach(function (it) {
    it.querySelector('.pv-acc-h').addEventListener('click', function () {
      var open = it.classList.contains('open');
      items.forEach(function (o) { o.classList.remove('open'); o.querySelector('.pv-acc-h span').textContent = '+'; });
      if (!open) { it.classList.add('open'); it.querySelector('.pv-acc-h span').textContent = '−'; }
    });
  });

  // ── nested accordion (level 2, e.g. notes acts) ──
  var subs = [].slice.call(rev.querySelectorAll('.pv-acc2-item'));
  subs.forEach(function (it) {
    it.querySelector('.pv-acc2-h').addEventListener('click', function () {
      var open = it.classList.contains('open');
      var group = it.parentElement.children;
      [].forEach.call(group, function (o) { o.classList.remove('open'); var sp = o.querySelector('.pv-acc2-h span'); if (sp) sp.textContent = '+'; });
      if (!open) { it.classList.add('open'); it.querySelector('.pv-acc2-h span').textContent = '−'; }
    });
  });

  // ── circular donut text ring (build glyphs, rAF spin with hover speed-up) ──
  rev.querySelectorAll('.pv-donut[data-circtext]').forEach(function (el) {
    var text = el.getAttribute('data-circtext');
    if (!text) return;
    var letters = Array.from(text);
    letters.forEach(function (ch, i) {
      var s = document.createElement('span');
      s.textContent = ch;
      s.style.transform = 'rotateZ(' + (360 / letters.length) * i + 'deg)';
      el.appendChild(s);
    });
    var SPIN = 15, speed = 360 / SPIN, target = speed, cur = speed, angle = 0, last = null;
    el.addEventListener('mouseenter', function () { target = speed * 4; });
    el.addEventListener('mouseleave', function () { target = speed; });
    function step(ts) {
      if (last !== null) {
        cur += (target - cur) * 0.08;
        angle = (angle + cur * (ts - last) / 1000) % 360;
        el.style.transform = 'rotate(' + angle + 'deg)';
      }
      last = ts;
      requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  });

  // ── delivery estimate from a PIN (swarm plan A.4): honest arithmetic from the shipping policy,
  //    no API, no promise. Numbers come from the hero section's settings via data-*.
  (function () {
    var box = document.getElementById('pvDeliver'), pin = document.getElementById('pvPin');
    var go = document.getElementById('pvPinGo'), out = document.getElementById('pvDlOut');
    if (!box || !pin || !go || !out) return;
    var cfg = box.dataset;
    var METRO = (cfg.metro || '110,400,700,600,560,500,411,380').split(/[^0-9]+/).filter(Boolean);
    var dMin = +cfg.dispatchMin || 48, dMax = +cfg.dispatchMax || 72, mMin = +cfg.metroMin || 3, mMax = +cfg.metroMax || 5, rMin = +cfg.restMin || 5, rMax = +cfg.restMax || 7;
    function skipSunday(d) { while (d.getDay() === 0) d.setDate(d.getDate() + 1); return d; }
    function addWorking(d, n) { d = new Date(d); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0) n--; } return d; }
    function fmt(d) { return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); }
    function estimate(p) {
      var metro = METRO.indexOf(p.slice(0, 3)) > -1, now = new Date();
      var a = skipSunday(new Date(now.getTime() + dMin * 36e5)), b = skipSunday(new Date(now.getTime() + dMax * 36e5));
      var lo = addWorking(a, metro ? mMin : rMin), hi = addWorking(b, metro ? mMax : rMax);
      return 'Estimated between ' + fmt(lo) + ' and ' + fmt(hi) + ' for ' + p + '. Dispatch takes ' + dMin + ' to ' + dMax + ' hours; the house does not dispatch on Sundays or public holidays, so a holiday can add a day.';
    }
    function run() {
      var p = pin.value.replace(/\D/g, '');
      if (!/^[1-9][0-9]{5}$/.test(p)) { out.textContent = 'Enter a 6-digit PIN code.'; out.classList.add('err'); return; }
      out.classList.remove('err'); out.textContent = estimate(p);
      try { localStorage.setItem('mz-pin', p); } catch (e) {}
    }
    go.addEventListener('click', run);
    pin.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); run(); } });
    try { var s = localStorage.getItem('mz-pin'); if (s) { pin.value = s; run(); } } catch (e) {}
  })();

  // ── share (Web Share API, copy-link fallback) ──
  (function () {
    var b = document.getElementById('pvShare'); if (!b) return;
    b.addEventListener('click', function () {
      var data = { title: document.title, url: location.href };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      (navigator.clipboard ? navigator.clipboard.writeText(location.href) : Promise.reject()).then(function () {
        b.textContent = 'Link copied'; setTimeout(function () { b.textContent = 'Share'; }, 1800);
      }, function () { prompt('Copy this link', location.href); });
    });
  })();

  // ── preorder switch (the static page's #pvRailX): body[data-stock="preorder"] sends the page's
  //    "#buy" links to the preorder form. Opening the form is assets/mz-preorder.js's job (the CTA's
  //    aria-controls + its delegated #preorder click), exactly as on the static page; a second
  //    opener here used to force the form open on load, which the static page never does. ──
  if (document.body.dataset.stock === 'preorder') {
    document.querySelectorAll('a[href="#buy"]').forEach(function (a) { a.setAttribute('href', '#preorder'); });
  }

  // ── Discovery Set: fit the wide case photo against the buy rail's height ──
  var setBottle = rev.querySelector('.pv-bottle.set');
  if (setBottle) {
    var railEl = rev.querySelector('.pv-buy');
    (function fitSetHero() {
      function fit() {
        if (!railEl || innerWidth < 900) { setBottle.removeAttribute('style'); return; }
        var fr = rev.getBoundingClientRect(), rr = railEl.getBoundingClientRect();
        var dn = rev.querySelector('.pv-donut'), t0 = Math.min(rr.top, dn ? dn.getBoundingClientRect().top : rr.top);
        var top = t0 - fr.top, h = rr.bottom - t0, gutter = fr.width * 0.035, gap = Math.max(32, fr.width * 0.05);
        // v413 (static): never taller than what is on screen from its own top down - a fixed rail-height box ran
        // past the fold on short laptops and overflow:hidden cut the bottles off.
        h = Math.min(h, innerHeight - (fr.top + top) - 16);
        var avail = (rr.left - fr.left) - gap - gutter, w = Math.min(h, avail);
        setBottle.style.cssText = 'top:' + top + 'px;bottom:auto;height:' + h + 'px;width:' + w + 'px;left:' + (gutter + (avail - w) / 2) + 'px;' +
          'aspect-ratio:auto;transform:none;opacity:1;transition:none';
      }
      fit();
      addEventListener('load', fit);
      addEventListener('resize', fit);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    })();
  }
})();
